@if (hasBreadcrumbs()) {
  <div class="breadcrumb-container">
    <!-- Mobile Hamburger Menu Button (For chat routes and workspace routes) -->
    @if ((isOnChatRoute() || isOnWorkspaceRoute()) && shouldShowHamburger()) {
      <button
        mat-icon-button
        class="hamburger-menu-btn"
        (click)="onToggleSidebar()"
        [attr.aria-label]="'NAVIGATION.BREADCRUMBS.TOGGLE_HISTORY' | translate"
      >
        <mat-icon>menu</mat-icon>
      </button>
    }

    <!-- Breadcrumb Navigation -->
    <nav
      class="breadcrumb-nav"
      [attr.aria-label]="'NAVIGATION.BREADCRUMBS.NAVIGATION_LABEL' | translate"
    >
      <ol class="breadcrumb-list">
        @for (breadcrumb of breadcrumbs(); track $index) {
          <li class="breadcrumb-item">
            @if (breadcrumb.clickable) {
              <a
                class="breadcrumb-link"
                (click)="onBreadcrumbClick($event, $index)"
                [attr.aria-label]="
                  'NAVIGATION.BREADCRUMBS.NAVIGATE_TO'
                    | translate
                      : {
                          label: breadcrumb.translationKey
                            ? (breadcrumb.translationKey | translate)
                            : breadcrumb.label,
                        }
                "
                tabindex="0"
                (keydown.enter)="onBreadcrumbClick($event, $index)"
                (keydown.space)="onBreadcrumbClick($event, $index)"
              >
                @if (breadcrumb.translationKey) {
                  {{ breadcrumb.translationKey | translate }}
                } @else {
                  {{ breadcrumb.label }}
                }
              </a>
            } @else {
              <span class="breadcrumb-current" aria-current="page">
                @if (breadcrumb.translationKey) {
                  {{ breadcrumb.translationKey | translate }}
                } @else {
                  {{ breadcrumb.label }}
                }
              </span>
            }

            @if ($index < breadcrumbs().length - 1) {
              <mat-icon class="breadcrumb-separator" aria-hidden="true">
                chevron_right
              </mat-icon>
            }
          </li>
        }
      </ol>
    </nav>
  </div>
}
